import { api } from "../api";
export const faqApi = api.injectEndpoints({
    endpoints: (build) => ({
        getFaq: build.query({
            query: (args) => ({
                url: `program-service/api/v1/widget/faqs`,
                headers: {
                    "X-Loyalty-Language": (args.locale).split('-')[0],
                    "Authorization": `Bearer ${args.jwt}`
                }
            }),
            forceRefetch: () => true
        })
    })
});
//# sourceMappingURL=faq.api.js.map